import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import { FaSave, FaArrowLeft, FaShieldAlt } from 'react-icons/fa';
import { getPermissions, updateRole, assignPermissionsToRole, clearState, getRoleDetails } from '../../../redux/Slices/authSlice';
import { useTitle } from '../../../shared/context/TitleContext';
import { useTranslation } from 'react-i18next';
import { showSuccessToast, showErrorToast, showWarningToast, showInfoToast } from '../../../shared/utils/toastHelper';

import { Link, useNavigate, useParams } from 'react-router-dom';

const EditRole = () => {
  
  const { t } = useTranslation('global');
  const { setTitle } = useTitle();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { permissions, permissionsPagination, roleDetails, isLoading, error, success } = useSelector((state) => state.auth);
  


  const [roleData, setRoleData] = useState({
    name_ar: '',
    name_en: '',
    permission_id: []
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [originalRole, setOriginalRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    setTitle('sidenav.editRole');
    // تنظيف الـ success state القديم فوراً
    dispatch(clearState());
    dispatch(getPermissions(currentPage));
    
    // جلب بيانات الدور من الـ API
    if (id) {
      dispatch(getRoleDetails(id));
    }
    
    // الحصول على بيانات الصلاحية من الـ sessionStorage
    const roleDataFromStorage = sessionStorage.getItem(`role_${id}`);
    const selectedRoleFromStorage = sessionStorage.getItem('selectedRole');
    
   
    
    if (roleDataFromStorage) {
      try {
        const roleData = JSON.parse(roleDataFromStorage);
        setOriginalRole(roleData);
        
        // استخراج permission_id من البيانات
        let permissionIds = [];
        if (roleData.permission_id && roleData.permission_id.length > 0) {
          permissionIds = roleData.permission_id;
        } else if (roleData.permission && roleData.permission.length > 0) {
          permissionIds = roleData.permission.map(p => typeof p === 'object' ? p.id : p);
        } else if (roleData.permissions && roleData.permissions.length > 0) {
          permissionIds = roleData.permissions.map(p => typeof p === 'object' ? p.id : p);
        }
        
        const roleDataToSet = {
          name_ar: roleData.name_ar || roleData.name || '',
          name_en: roleData.name_en || '',
          permission_id: permissionIds
        };
        
   
        setRoleData(roleDataToSet);
        
     
        
        setRoleLoading(false);
      } catch (error) {
        setRoleLoading(false);
      }
    } else if (selectedRoleFromStorage) {
      try {
        const roleData = JSON.parse(selectedRoleFromStorage);
        setOriginalRole(roleData);
        
        let permissionIds = [];
        if (roleData.permission && roleData.permission.length > 0) {
          permissionIds = roleData.permission.map(p => typeof p === 'object' ? p.id : p);
        } else if (roleData.permissions && roleData.permissions.length > 0) {
          permissionIds = roleData.permissions.map(p => typeof p === 'object' ? p.id : p);
        }
        
        const roleDataToSet = {
          name_ar: roleData.name_ar || roleData.name || '',
          name_en: roleData.name_en || '',
          permission_id: permissionIds
        };
        
        setRoleData(roleDataToSet);
        
       
        
        setRoleLoading(false);
      } catch (error) {
        setRoleLoading(false);
      }
    } else {
      // إذا لم تكن البيانات موجودة، استخدم بيانات افتراضية
      setRoleData({
        name_ar: '',
        name_en: '',
        permission_id: []
      });
      setRoleLoading(false);
    }
  }, [dispatch, setTitle, currentPage, id]);

  // تحديث النموذج عند جلب بيانات الدور من الـ API
  useEffect(() => {
    if (roleDetails) {
      
      // استخراج permission_id من البيانات
      let permissionIds = [];
      if (roleDetails.permission_id && roleDetails.permission_id.length > 0) {
        permissionIds = roleDetails.permission_id;
      } else if (roleDetails.permission && roleDetails.permission.length > 0) {
        permissionIds = roleDetails.permission.map(p => typeof p === 'object' ? p.id : p);
      } else if (roleDetails.permissions && roleDetails.permissions.length > 0) {
        permissionIds = roleDetails.permissions.map(p => typeof p === 'object' ? p.id : p);
      }
      
      const roleDataToSet = {
        name_ar: roleDetails.name_ar || roleDetails.name || '',
        name_en: roleDetails.name_en || '',
        permission_id: permissionIds
      };
      
      setRoleData(roleDataToSet);
      setRoleLoading(false);
    }
  }, [roleDetails]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRoleData(prev => ({ ...prev, [name]: value }));
  };

  const handlePermissionChange = (permissionId) => {
    setRoleData(prev => ({
      ...prev,
      permission_id: prev.permission_id.includes(permissionId)
        ? prev.permission_id.filter(id => id !== permissionId)
        : [...prev.permission_id, permissionId]
    }));
  };

  const handleSelectAll = () => {
    const allPermissionIds = permissions.map(p => p.id);
    setRoleData(prev => ({
      ...prev,
      permission_id: prev.permission_id.length === allPermissionIds.length ? [] : allPermissionIds
    }));
  };

  useEffect(() => {
    if (success) {
      showSuccessToast(success, {
        position: "top-right",
        rtl: true,
        autoClose: 2000,
        onClose: () => {
          navigate('/admin-permissions');
        }
      });
      // تنظيف الـ success state بعد عرض التوست
      dispatch(clearState());
    }
  }, [success, navigate, dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
 
    
    // تنظيف أي رسائل قديمة قبل الإرسال
    dispatch(clearState());
    
    if (!roleData.name_ar?.trim()) {
      showErrorToast('يرجى إدخال الاسم بالعربية');
      return;
    }
    
    if (!roleData.name_en?.trim()) {
      showErrorToast('يرجى إدخال الاسم بالإنجليزية');
      return;
    }
    
    if (roleData.permission_id.length === 0) {
      showErrorToast('يرجى اختيار صلاحية واحدة على الأقل');
      return;
    }
    
    try {
      // تحديث الدور أولاً
      const roleUpdateData = {
        name_en: roleData.name_en,
        name_ar: roleData.name_ar
      };
      
      await dispatch(updateRole({ roleId: id, roleData: roleUpdateData })).unwrap();
      
      // ربط الصلاحيات بالدور
      if (roleData.permission_id.length > 0) {
        await dispatch(assignPermissionsToRole({
          roleId: id,
          permissions: roleData.permission_id
        })).unwrap();
      }
    } catch (error) {
    }
  };

  const handlePageChange = (page) => {
    if (isLoading) return; // منع النقر أثناء التحميل
    if (page === currentPage) return; // منع النقر على نفس الصفحة
    setCurrentPage(page);
    dispatch(clearState()); // تنظيف الـ success state عند تغيير الصفحة
    dispatch(getPermissions(page)); // إعادة جلب البيانات للصفحة الجديدة
  };

  const LoadingSpinner = () => (
    <div className="spinner-border text-primary" role="status" style={{ width: '1.5rem', height: '1.5rem' }}>
      <span className="visually-hidden">Loading...</span>
    </div>
  );

  const Pagination = () => {
    if (!permissionsPagination || permissionsPagination.last_page <= 1) return null;

    const pages = [];
    const { current_page, last_page } = permissionsPagination;

    // زر السابق - ثابت دائماً
    pages.push(
      <button
        key="prev"
        className={`btn btn-sm mx-1 ${current_page > 1 ? 'btn-outline-primary' : 'btn-outline-secondary'}`}
        onClick={() => current_page > 1 && handlePageChange(current_page - 1)}
        disabled={current_page <= 1 || isLoading}
      >
        السابق
      </button>
    );

    // عرض جميع الصفحات المتاحة
    for (let i = 1; i <= last_page; i++) {
      pages.push(
        <button
          key={i}
          className={`btn btn-sm mx-1 ${i === current_page ? 'btn-primary' : 'btn-outline-primary'}`}
          onClick={() => handlePageChange(i)}
          disabled={isLoading}
        >
          {i}
        </button>
      );
    }

    // زر التالي - ثابت دائماً
    pages.push(
      <button
        key="next"
        className={`btn btn-sm mx-1 ${current_page < last_page ? 'btn-outline-primary' : 'btn-outline-secondary'}`}
        onClick={() => current_page < last_page && handlePageChange(last_page)}
        disabled={current_page >= last_page || isLoading}
      >
        التالي
      </button>
    );

    return (
      <div className="d-flex justify-content-center mt-3">
        {pages}
      </div>
    );
  };

  if (roleLoading) {
    return (
      <div className="container-fluid py-4">
        <div className="text-center py-5">
          <LoadingSpinner />
          <p className="mt-3 text-muted">جاري تحميل بيانات الصلاحية...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      
      
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="d-flex align-items-center mb-3">
            <Link to="/roles" className="text-decoration-none mx-3">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="btn btn-outline-secondary btn-sm"
                style={{ borderRadius: '8px' }}
              >
                <FaArrowLeft className="mx-2" />
                العودة
              </motion.button>
            </Link>
            <h4 className="mb-0 fw-bold" style={{ color: '#184194', fontSize: '1.1rem' }}>
              <FaShieldAlt className="mx-2" />
              تعديل الصلاحية
            </h4>
          </div>
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="card shadow-lg border-0 p-3"
            style={{ borderRadius: '15px' }}
          >
            <div className="card-header bg-white border-0 py-3">
              <h4 className="text-center mb-0 fw-bold" style={{ color: '#184194', fontSize: '1.3rem' }}>
                تعديل بيانات الصلاحية
              </h4>
            </div>

            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                {/* Role Names */}
                <div className="row mb-4">
                  <div className="col-md-6">
                    <label className="form-label fw-medium">الاسم بالعربية</label>
                    <input
                      type="text"
                      name="name_ar"
                      value={roleData.name_ar}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="أدخل الاسم بالعربية"
                      required
                      style={{ borderRadius: '10px' }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-medium">الاسم بالإنجليزية</label>
                    <input
                      type="text"
                      name="name_en"
                      value={roleData.name_en}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter name in English"
                      required
                      style={{ borderRadius: '10px' }}
                    />
                  </div>
                </div>

                {/* Permissions Selection */}
                <div className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <label className="form-label fw-medium mb-0">الصلاحيات</label>
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={handleSelectAll}
                      style={{ borderRadius: '8px' }}
                    >
                      {roleData.permission_id.length === permissions.length ? 'إلغاء الكل' : 'اختيار الكل'}
                    </button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-4">
                      <LoadingSpinner />
                      <p className="mt-3 text-muted">جاري تحميل الصلاحيات...</p>
                    </div>
                  ) : (
                    <div className="row">
                      {permissions.map((permission) => (
                        <div key={permission.id} className="col-md-6 col-lg-4 mb-3">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`permission-${permission.id}`}
                              checked={roleData.permission_id.includes(permission.id)}
                              onChange={() => handlePermissionChange(permission.id)}
                            />
                            <label className="form-check-label" htmlFor={`permission-${permission.id}`}>
                              {permission.name}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <Pagination />
                </div>

                {/* Selected Permissions Count */}
                {roleData.permission_id.length > 0 && (
                  <div className="alert alert-info mb-4">
                    <strong>تم اختيار {roleData.permission_id.length} صلاحية</strong>
                  </div>
                )}

                {/* Submit Button */}
                <div className="text-center">
                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    type="submit"
                    className="btn text-white px-5 py-2 fw-medium"
                    style={{
                      backgroundColor: '#184194',
                      border: 'none',
                      borderRadius: '10px',
                      fontSize: '1rem'
                    }}
                    disabled={isLoading}
                  >
                    {isLoading ? <LoadingSpinner /> : (
                      <>
                        <FaSave className="mx-2" />
                        حفظ التغييرات
                      </>
                    )}
                  </motion.button>
                </div>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default EditRole;
